import React from 'react'
import classnames from 'classnames'
import styles from './style.styl'

const GDPRMessage = () => (
  <div className="gdpr-message">
    Drift respects privacy rights and data protection laws.
    You may only share other people's personal information with Drift,
    whether directly or through third-party integrations, if you are permitted
    to do so under applicable law.
    <a rel="noopener noreferrer" target="_blank" href="https://www.drift.com/privacy-policy/"> View our Privacy Policy.</a>
  </div>
)

export default GDPRMessage



// WEBPACK FOOTER //
// ./src/scripts/components/GDPRMessage/index.js